module.exports = __webpack_public_path__ + "img/draw-rules-left.79c8b163.png";